import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {DraggableCore, DraggableData} from 'react-draggable';
import bind from 'bind-decorator';
import {action, observable} from 'mobx';
import {FlowDragContext, FlowDropContext, FlowPoint} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {
    CloudComponentPreview,
    CloudComponentPreviewMode
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/components/CloudComponentPreview';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';

const styles = require('./FlowEditorGlass.less');
const cx = classnames.bind(styles);

export interface FlowEditorGlassProps
{
}

@observer
export class FlowEditorGlass extends React.Component<FlowEditorGlassProps, any>
{
    private _glassRef:HTMLElement;
    private _draggableRef:DraggableCore;

    @observable
    private _curPoint:FlowPoint = null;

    @bind
    private _onGlassRef(ref:HTMLElement)
    {
        this._glassRef = ref;
    }

    @bind
    private _onDraggableRef(ref:any)
    {
        this._draggableRef = ref;

        const {glass} = rootState.ui.visualDesigner.flow;
        const dragContext = glass.dragContext;

        if( dragContext )
        {
            const e = dragContext.mouseEvent;
            (this._draggableRef as any).handleDragStart(e);
        }
    }

    @action.bound
    private _onDrag(e:MouseEvent, data:DraggableData):void
    {
        if( !this._curPoint )
            return;

        const newX = this._curPoint.x + data.deltaX;
        const newY = this._curPoint.y + data.deltaY;

        this._curPoint = new FlowPoint(newX, newY);
    }

    @action.bound
    private _onDragStop(e:MouseEvent, data:DraggableData):void
    {
        const {glass} = rootState.ui.visualDesigner.flow;
        const dragContext = glass.dragContext;
        const dropContext = new FlowDropContext(this._curPoint, dragContext.componentToDrag);

        controllers.ui.flowCanvas.addNewBlock(dropContext);

        glass.dragContext = null;
        this._curPoint = null;
    }

    private _renderDragItem():JSX.Element
    {
        const {glass} = rootState.ui.visualDesigner.flow;
        const dragContext = glass.dragContext;

        if( !dragContext )
            return null;

        if( !this._curPoint )
            this._curPoint = this._computeInitialPositionOnGlass(dragContext);

        const style = this._curPoint.toCssStyle();

        return (
            <DraggableCore ref={this._onDraggableRef}
                           onDrag={this._onDrag}
                           onStop={this._onDragStop}
                           enableUserSelectHack={false}
            >
                <div style={style}>
                    <CloudComponentPreview isVisible={true}
                                           className={cx('draggingCloudComponentPreview')}
                                           component={dragContext.componentToDrag}
                                           mode={CloudComponentPreviewMode.IconBlock} />
                </div>
            </DraggableCore>
        );
    }

    private _computeInitialPositionOnGlass(dragContext:FlowDragContext):FlowPoint
    {
        const {elementBoundingClientRect} = dragContext;

        let x = elementBoundingClientRect.left;
        let y = elementBoundingClientRect.top;

        x -= this._glassRef.getBoundingClientRect().left + 20; // todo: figure out why there is a need for 20px offset here
        y -= this._glassRef.getBoundingClientRect().top;

        return new FlowPoint(x, y);
    }

    render()
    {
        return (
            <Row aRef={this._onGlassRef} className={cx('flowEditorGlass')}>
                {this._renderDragItem()}
            </Row>
        );
    }
}
